import type {
  AdminCreateXeroInvoiceRequestType,
  AdminCreateXeroInvoiceResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useXeroCreateFailedInvoice = () => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (data: AdminCreateXeroInvoiceRequestType) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `xero/admin-create-failed-invoice`,
        data,
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as AdminCreateXeroInvoiceResponseType,
      ),

    onSuccess: (response) => {
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Orders],
      });
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.Orders,
          response.orderId,
        ],
      });
    },
  });
};
